export interface DrpSearchConfig {
  claimVendorLocationsUrl: string;
  geoApiUrl: string;
}

export const initialState: DrpSearchConfig = {
  claimVendorLocationsUrl: null,
  geoApiUrl: null
};
